export const getSchoolCode = props => {
  const { match } = props;
  const { params } = match || {};
  const { schoolCode, ...other } = params || {};
  return { schoolCode, ...other, ...props };
};
